module.exports = __webpack_public_path__ + "img/clevik.8d81abb1.png";